module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 161
// module chunks = 0